import React, { useState } from "react";
import { Row, Col, Typography, Input, Button, Form, Card, message } from "antd";
import { ReloadOutlined } from "@ant-design/icons";
import "./HasarIhbarTrafikPage.css";
import { useNavigate } from "react-router-dom";
import { useHasar } from "../HasarContext";
import getConfig from "../config";

// Set global message config for position
message.config({
    top: 24,
    right: 24,
    duration: 3,
    maxCount: 3,
});

const { Title } = Typography;

function HasarIhbarTrafikPage() {
    const [captcha1, setCaptcha1] = useState(Math.floor(Math.random() * 10) + 1);
    const [captcha2, setCaptcha2] = useState(Math.floor(Math.random() * 10) + 1);
    const [form] = Form.useForm();
    const navigate = useNavigate();
    const { setToken, setPlaka, setPoliceNo } = useHasar();

    const handleReloadCaptcha = () => {
        setCaptcha1(Math.floor(Math.random() * 10) + 1);
        setCaptcha2(Math.floor(Math.random() * 10) + 1);
        form.setFieldsValue({ captchaInput: "" });
    };

    const handleSubmit = async (values) => {
        const captchaResult = Number(values.captchaInput);
        if (captchaResult !== captcha1 + captcha2) {
            message.error("Güvenlik kodu hatalı. Lütfen doğru toplamı giriniz.");
            return;
        }
        handleReloadCaptcha();

        // API çağrısı için body'yi uygun şekilde oluştur
        const body = {
            CariPoliceNo: values.policeNo,
            Aciklama: values.plaka,// plaka -> aciklama
            TarifeKod: "K50"
        };

        const config = getConfig();
        const response = await fetch(`${config.apiBaseUrl}/Hasar/PoliceVarlikKontrol`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(body)
        });

        if (response.ok) {
            const data = await response.json();
            setToken(data.token);
            setPoliceNo(values.policeNo);
            setPlaka(values.plaka);
            navigate("/trafik/ihbar");
        } else {
            message.error("Girilen bilgiler hatalıdır. Lütfen kontrol ediniz.");
            return;
        }
    };

    return (
        <div className="trafik-container">
            <div className="trafik-header">
                <Row gutter={[16, 16]} align="middle">
                    <Col xs={24} md={12}>
                        <Title level={1} className="trafik-title">Hasar İhbarı Trafik</Title>
                    </Col>
                    <Col xs={24} md={12} className="trafik-image-col">
                        <div className="trafik-image-wrapper">
                            <svg width="140" height="140" viewBox="0 0 140 140" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M140 70C140 108.66 108.66 140 70 140C31.34 140 0 108.66 0 70C0 31.34 31.34 0 70 0C108.66 0 140 31.34 140 70Z" fill="#DDE5E4"></path>
                                <path d="M70.71 16.57C70.51 16.03 70.15 15.97 70 15.97C69.85 15.97 69.49 16.03 69.29 16.57L52.13 63.76L52.52 63.73H87.33C87.64 63.73 87.92 63.93 88.03 64.22L70.71 16.57Z" fill="#0076BE"></path>
                                <path d="M46.81 79.78H93.2C93.5 79.78 93.77 79.97 93.87 80.25L95.58 84.94L88.04 64.21C87.93 63.92 87.65 63.72 87.34 63.72H52.53L52.14 63.75L45.43 82.2L46.14 80.25C46.24 79.97 46.51 79.78 46.81 79.78Z" fill="#A7CFEE"></path>
                                <path d="M93.86 80.25C93.76 79.97 93.49 79.78 93.19 79.78H46.8C46.5 79.78 46.23 79.97 46.13 80.25L35.45 109.62H104.55L93.86 80.25Z" fill="#0076BE"></path>
                                <path d="M110.14 109.62H29.86C28.34 109.62 27.11 110.85 27.11 112.37C27.11 113.89 28.34 115.12 29.86 115.12H110.14C111.66 115.12 112.89 113.89 112.89 112.37C112.89 110.85 111.66 109.62 110.14 109.62Z" fill="#5491CD"></path>
                            </svg>
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="trafik-form-wrapper">
                <Card className="trafik-form-card" bordered={false}>
                    <Form
                        form={form}
                        layout="vertical"
                        onFinish={handleSubmit}
                        autoComplete="off"
                    >
                        <Form.Item
                            name="policeNo"
                            rules={[
                                { required: true, message: "Poliçe Numarası giriniz" },
                                { pattern: /^[0-9]+$/, message: "Sadece rakam giriniz" }
                            ]}
                        >
                            <Input
                                size="large"
                                placeholder="Poliçe Numarası"
                                inputMode="numeric"
                                pattern="[0-9]*"
                                maxLength={20}
                            />
                        </Form.Item>
                        <Form.Item
                            name="plaka"
                            rules={[{ required: true, message: "Sigortalı Plaka giriniz" }]}
                        >
                            <Input
                                size="large"
                                placeholder="Sigortalı Plaka"
                                onChange={e => {
                                    const upperValue = e.target.value.toUpperCase();
                                    form.setFieldsValue({ plaka: upperValue });
                                }}
                            />
                        </Form.Item>
                        <div className="trafik-captcha-label">GÜVENLİK KODU</div>
                        <div className="trafik-captcha-row">
                            <div className="trafik-captcha-box">
                                <span className="trafik-captcha-text">{captcha1} + {captcha2} = ?</span>
                                <Button
                                    type="text"
                                    icon={<ReloadOutlined />}
                                    onClick={handleReloadCaptcha}
                                    className="trafik-captcha-reload"
                                />
                            </div>
                            <Form.Item
                                name="captchaInput"
                                rules={[{ required: true, message: "Güvenlik Kodunu giriniz" }]}
                                style={{ marginBottom: 0 }}
                            >
                                <Input
                                    size="large"
                                    className="trafik-captcha-input"
                                    placeholder="Toplam"
                                    inputMode="numeric"
                                    pattern="[0-9]*"
                                />
                            </Form.Item>
                        </div>
                        <Form.Item>
                            <Button type="primary" htmlType="submit" size="large" block>
                                SORGULA
                            </Button>
                        </Form.Item>
                    </Form>
                </Card>
            </div>
        </div>
    );
}

export default HasarIhbarTrafikPage;
